export const DEFAULT_FINGER_PRINT_VALUE = '-1';
